import {footerActionTypes} from "./actionTypes";

export function setFooter(value) {
    return {
        type: footerActionTypes.SET_FOOTER,
        payload: value
    }
}